export const projects = [
  {
    projectImgLink:
      'https://images.velog.io/images/seonja/post/46de7834-1741-4946-a380-b795305f3210/image.png',
    projectTitle: 'Editor MVP',
    projectSummary: `개발한 기능 자체는 간단하지만 Editor를 구현하기 위해서 어떤 framework를 사용해야 하는지에 대한 고민과 bundler(Rollup, Parcel, Webpack)을 직접 사용해본 후 가장 적합하다고 생각한 Webpack을 세팅할 때까지의 고민이 담겨있는 프로젝트입니다. 
    깃허브에 방문하셔서 꼭 README를 읽어주세요.`,
    libraryList: [
      'https://images.velog.io/images/seonja/post/0a92b5ae-c483-4aae-a23e-6d157daaf1af/pngaaa.com-2507896.png',
    ],
    github: 'https://github.com/seonjakim/editor',
    webpage: 'https://seonjakim.github.io/editor/',
  },
  {
    projectImgLink:
      'https://images.velog.io/images/seonja/post/85898d11-e36f-49f0-b04e-7d481e1105ce/image.png',
    projectTitle: 'Spinbox',
    projectSummary: `이 프로젝트를 통해 리액트의 특성이기도 한 stale closures에 대한 이해와 useState가 어떻게 batching되어서 렌더되고 그 과정에서 발생할 수 있는 오류에 대해 알게 되었습니다. 이를 해결할 수 있는 함수형 업데이트(Functional Updates)와 React의 특성인 Stale closure에 대해 이해할 수 있었던 프로젝트입니다.

    `,
    libraryList: [
      'https://images.velog.io/images/seonja/post/0a92b5ae-c483-4aae-a23e-6d157daaf1af/pngaaa.com-2507896.png',
    ],
    github: 'https://github.com/seonjakim/spinbox',
    webpage: 'https://seonjakim.github.io/spinbox/',
  },
  {
    projectImgLink:
      'https://images.velog.io/images/seonja/post/5d7ff6f4-614e-47b1-9457-2ca1d348126f/%E1%84%91%E1%85%B5%E1%86%AF%E1%84%85%E1%85%B5%E1%84%8E%E1%85%AC%E1%84%8C%E1%85%A9%E1%86%BC%E1%84%87%E1%85%A9%E1%86%AB.gif',
    projectTitle: 'Willy',
    projectSummary:
      '프론트엔드 개발자 3명, 백엔드 개발자 3명에서 진행한 Pilly (건강 보조제 구독 서비스) 웹사이트 클로닝 팀 프로젝트에서 REST api에 맞춰 장바구니를 구현하였습니다.',
    libraryList: [
      'https://images.velog.io/images/seonja/post/0a92b5ae-c483-4aae-a23e-6d157daaf1af/pngaaa.com-2507896.png',
      'https://images.velog.io/images/seonja/post/c0040fe4-11b7-4add-a8ea-801aa1322f60/image.png',
    ],
    github: 'https://github.com/seonjakim/Pilly-frontend',
  },
  // {
  //   projectImgLink:'',
  //   projectTitle:'',
  //   projectSummary:'',
  //   libraryList:[]
  // }
]

export const skills = [
  {
    library: 'React',
    png: 'https://images.velog.io/images/seonja/post/0a92b5ae-c483-4aae-a23e-6d157daaf1af/pngaaa.com-2507896.png',
  },
  {
    library: 'HTML',
    png: 'https://images.velog.io/images/seonja/post/70b5fb26-2e04-46c8-974d-58ac65ab38f3/image.png',
  },
  {
    library: 'CSS',
    png: 'https://images.velog.io/images/seonja/post/eccae86d-5829-4bc0-a226-c91770f4ceb4/image.png',
  },
  {
    library: 'JS',
    png: 'https://images.velog.io/images/seonja/post/fa574282-8c93-4c6a-8f62-145d9b7067ac/image.png',
  },
  {
    library: 'Git',
    png: 'https://chippd.github.io/img/tool-logos/git.png',
  },
  {
    library: 'Jira',
    png: 'https://storiesonboard.com/images/jira.svg',
  },
  {
    library: 'Slack',
    png: 'https://storiesonboard.com/images/slack.svg',
  },
  // {
  //   library: '',
  //   png: '',
  // },
  // {
  //   library:'',
  //   png:''
  // },
]
